export const PAR_SOLUTIONS = [
  "PAR Scales",
  "PAR 360 Plus",
  "PAR 360 Premium",
  "Electronic Shelf Labels (ESLs)",
  "TrackCore IR",
  "TrackCore OR",
  "PAR SameDay",
  "Notisphere",
] as const;

export const PAR360_PLUS = "PAR 360 Plus";
export const PAR360_PREMIUM = "PAR 360 Premium";

export const hasPar360Solution = (solutions?: string[] | null): boolean =>
  (solutions ?? []).some((s) => s === PAR360_PLUS || s === PAR360_PREMIUM);
